import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {License} from "../../../models/licenses-model/license.model";
import {LicensesService} from "../../../services/licenses-service/licenses.service";

@Component({
  selector: 'app-devices-register-iot-dialog',
  templateUrl: './devices-register-iot-dialog.component.html',
  styleUrls: ['./devices-register-iot-dialog.component.scss']
})
export class DevicesRegisterIOTDialogComponent implements OnInit, OnDestroy {

  centers: CenterLite[];
  licenses: License[];
  error;
  basicDataForm = new FormGroup({
    platform: new FormControl('IOT', Validators.required),
    name: new FormControl(null, Validators.required),
    selectedCenter: new FormControl(null, Validators.required),
    type: new FormControl(null, Validators.required),
    model: new FormControl(null, Validators.required),
    brand: new FormControl(null, Validators.required),
    serialNumber: new FormControl(null),
    ipAddress: new FormControl(null),
    iotVersion: new FormControl(null),
    urlWebhook: new FormControl(null),
    properties: new FormControl(null),
    selectedLicense: new FormControl(null, Validators.required),
  });
  addIOTSubscription: Subscription;
  getLicensesSubscription: Subscription;

  constructor(public dialogRef: MatDialogRef<DevicesRegisterIOTDialogComponent>,
              public devicesService: DevicesDevicesService,
              private snackbarService: SnackBarService,
              private licensesService: LicensesService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.getLicenses();
    this.centers = this.userStorageService.getCenterList();
  }

  public getLicenses() {
    this.getLicensesSubscription = this.licensesService.getLicenses().subscribe(
      (res) => {
        this.licenses = res;
        this.basicDataForm.patchValue({
          selectedLicense: this.licenses[0]
        });
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public addIOT() {
    this.error = '';
    const validation = this.validateForm();
    if (validation === true) {
      this.addIOTSubscription = this.devicesService.addIOTWithLicense(this.basicDataForm).pipe(
        tap(o => this.dialogRef.close()),
        tap(o => this.snackbarService.open('devices-page.snackbar messages.link device success', 'success')),
        tap(o => this.devicesService.refreshDevices()),
        catchError(err => this.error += err['error']['message'])
      ).subscribe();
    } else {
      this.error = validation;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'devices-page.snackbar messages.name iot error';
    } if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'devices-page.snackbar messages.selected center iot error';
    } if (!this.basicDataForm.get('type').valid) {
      return 'devices-page.snackbar messages.type iot error';
    } if (!this.basicDataForm.get('model').valid) {
      return 'devices-page.snackbar messages.model iot error';
    } if (!this.basicDataForm.get('brand').valid) {
      return 'devices-page.snackbar messages.brand iot error';
    } if (!this.basicDataForm.get('selectedLicense').valid) {
      return 'devices-page.snackbar messages.selected license iot error';
    } else {
      return true;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public keyvalueOutputChanged(e) {
    this.basicDataForm.patchValue({
      properties: e
    });
  }

  ngOnDestroy() {
    if (this.addIOTSubscription) { this.addIOTSubscription.unsubscribe(); }
    if (this.getLicensesSubscription) { this.getLicensesSubscription.unsubscribe(); }
  }

}
